/**
 * KAN-783: периоды блока "Продажи по менеджерам" по Москве: неделя (последние
 * 7 дней включая сегодня), месяц (с 1 числа по сегодня), свой период
 * (CrmRangePicker). Сегодня берётся через todayMoscow из lib/crmTable.
 */
import { addDays } from './crmRange';
import type { CrmRange } from './crmTable';

export type SalesPeriodPreset = 'week' | 'month' | 'custom';

export const SALES_PERIOD_TABS: readonly { value: SalesPeriodPreset; label: string }[] = [
  { value: 'week', label: 'Неделя' },
  { value: 'month', label: 'Месяц' },
  { value: 'custom', label: 'Период' },
];

/** Период пресета от `today` (ГГГГ-ММ-ДД); для custom - `current`, без него сегодня. */
export function rangeFor(preset: SalesPeriodPreset, today: string, current?: CrmRange): CrmRange {
  if (preset === 'week') return { from: addDays(today, -6), to: today };
  if (preset === 'month') return { from: `${today.slice(0, 8)}01`, to: today };
  return current ?? { from: today, to: today };
}
